<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <header_promotion_name header="โปรโมชั่น" :img_header="header_image" :promotion_code="header_list.promotion_code" link_back="stock/promotion_stock/promotionexp"/>
      <v-card elevation="6">
        <div class="ma-4 pa-2">
          <headerexpire_promotion :expire_date="diff_dateTH(header_list.end_date)" :promotion_price="format_Price(header_list.price_per_set)" :expire_product="diff_dateTH(header_list.end_date)" name="จํานวนคงเหลือปัจจุบัน" :unit="header_list.quantity" :unit_name="detail_list.unit_name" :product_name="detail_list.product_name" :price_unit="format_Price(header_list.count_sale)" product_unit="บาท"/>
          <div class="grid_detail mt-10 mb-n10">
            <div>รายละเอียด :</div>
            <div class="ml-2">{{ header_list.note }}</div>
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail" class="grid_btn">
              <tr>
                <td>{{ dataDetail.item.lot_no }}</td>
                <td>{{ diff_dateTH(dataDetail.item.date_expired) }}</td>
                <td>{{ dataDetail.item.quantity }}</td>
                <td>{{ dataDetail.item.supplier_name }}</td>
                <td>{{ format_Price(dataDetail.item.cost) }}</td>
              </tr>
            </template>
          </v-data-table>
          <div v-if="date_raw >= date_now" class="pa-4">
            <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_date" :status="header_list.status"/>
          </div>
          <div v-else class="pa-4">
            <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_date" :status="0"/>
          </div>
          <div class="text-center mt-4 pb-4">
            <v-btn height="45" class="white--text grad-warning-bg btn_mobile mr-2" type="button" @click="getEdit()">แก้ไขโปรโมชั่น</v-btn>
            <v-btn height="45" class="white--text grad-danger-bg btn_mobile mr-2" type="button" @click="checkTransfer = true">ย้ายคืนคลังใกล้หมดอายุ</v-btn>
          </div>
        </div>
      </v-card>
      <v-dialog v-model="checkTransfer" persistent max-width="800">
        <v-card>
          <v-card-title>
            ย้ายคืนคลังใกล้หมดอายุ
          </v-card-title>
          <v-divider/>
          <div class="pa-5 text-center">
            <div>
              <p>คุณแน่ใจใช่ไหมที่จะทําการย้ายสินค้าโปรโมชั่นเข้าคลัง ใกล้หมดอายุ ?</p>
              <p>- โปรโมชั่นจะปิดการขายทันที</p>
              <p>- สินค้าโปรโมชั่นที่ค้างอยู่ในตะกร้าสินค้าของลูกค้าจะหายไป</p>
            </div>
          </div>
          <div class="text-right mt-4 pb-4 mr-4">
            <v-btn height="45" class="white--text grad-success-bg btn_size mr-2" type="button" @click="move_stock()">ยืนยันการย้ายคลัง</v-btn>
            <v-btn height="45" class="white--text grad-danger-bg btn_size" type="button" @click="backward()">ยกเลิก</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>

</template>

<script>
import header_promotion_name from "@/components/admin/stock/storage_promotion/header_promotion/header_promotion_name";
import headerexpire_promotion from "@/components/admin/stock/storage_promotion/header_promotion/headerexpire_promotion";
import usercreate_promotion from "@/components/admin/stock/storage_promotion/header_promotion/usercreate_promotion";
import HeaderImage from "@/assets/detail_1.png"
import {HTTP} from "@/axios";
import {diffChangeFormat, diffDateTH, formatPrice} from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_details",
  components: {
    usercreate_promotion,
    headerexpire_promotion,
    header_promotion_name
  },
  data() {
    return {
      header_image: HeaderImage,
      loading_page: false,
      search: null,
      checkTransfer: false,
      date_now: null,
      date_raw: null,
      date: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'ล็อต',
          value: 'lot_no',
          fixed: true,
          width: '120px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนคงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '160px',
        },
        {
          text: 'ซัพพลายเออร์',
          value: 'supplier_name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ราคาต้นทุน/หน่วย',
          value: 'cost',
          fixed: true,
          width: '200px',
        },
      ],
      header_list: [],
      detail_list: [],
      data_list: [],
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDate();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      // if (month < 10){
      //   month = '0'+ month
      // }
      // if (day < 10){
      //   day = '0'+ day
      // }
      let date = year + '-' + month + '-' + day
      this.date_now = Date.parse(date)
    },
    diff_change: function (value) {
      return diffChangeFormat(value)
    },
    diff_dateTH: function (value) {
      return diffDateTH(value)
    },
    format_Price: function(value) {
      return formatPrice(value)
    },
    getDetails() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/expireds/get', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.head
          this.date_raw = Date.parse(this.header_list.end_date)
          this.detail_list = res.data.detail
          this.data_list = res.data.lists
        }
      })
    },
    getEdit() {
      this.$router.push('/stock/promotion_stock/promotionedit/' + this.$route.params.id)
    },
    backward() {
      this.$router.push('/stock/promotion_stock/promotionexp')
    },
    move_stock() {
      HTTP.post('/inventory/promotions/expireds/cancel', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.$router.push('/stock/promotion_stock/promotionexp')
        }
      })
    },
  },
  mounted() {
    this.get_date()
    this.getDetails()
  }
}
</script>

<style scoped>
.grid_detail {
  display: grid;
  grid-template-columns: 15% 85%;
}
@media only screen and (max-width: 750px){
  .grid_detail {
    display: grid;
    grid-template-columns: 20% 80%;
  }
}
@media only screen and (max-width: 600px){
  .grid_detail {
    display: grid;
    grid-template-columns: 100%;
  }
  .btn_mobile {
    width: 100%;
    margin-top: 15px;
  }
}
</style>
